module.exports = __webpack_public_path__ + "static/media/zodiac_bg@1x.a104956b.dc511664.png";